import { staticComponentValueConverter } from '../StaticComponentValues';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getProductWithCategoryId } from '../../../../../../../helper/ThemeRequests';
import store from '../../../../../../../redux/store';
import { useDispatch } from 'react-redux';
import themeSlice from '../../../../../../../redux/themeSlice';
import { translate } from '../../../../../../../utils/language';
const createImageUrl = (imageId, merchantId) => {
  return imageId ? `https://cdn.myikas.com/images/${merchantId}/${imageId}/image_540.webp` : null;
};

function BaseProductGrid({ item, Product, productWidth, activeThemePageId }) {
  console.log(item);
  const collectionHashMap = useSelector(state => state.themeSlice?.collectionHashMap);
  const merchantId = store.getState()?.myUserSlice?.merchantId;
  const [dynamicImages, setDynamicImages] = useState([]);
  const dispatch = useDispatch();
  const productObject = useSelector(state => state.themeSlice.products);
  const products = productObject ? Object.values(productObject) : [];
  const dynamicImage = item?.data?.dynamicImages?.[0];
  const isDynamic = item?.data?.isDynamic;
  const images =
    activeThemePageId === 'AfterSearch' || activeThemePageId === 'ProductList' || activeThemePageId === 'Favorite'
      ? products
          ?.filter((product, index) => index < 8)
          .map(product => {
            return {
              image: {
                src: product?.image,
                text: product?.label,
              },
              pointTo: {
                pointTo: '',
                pointToType: '',
              },
              id: product?.id,
              creationId: '',
              type: 'product',
              useCustomImage: true,
              useCustomText: true,
              internalLinking: true,
            };
          })
      : item?.data?.images || [];
  const min = item?.variantData?.minImage;
  const customization = staticComponentValueConverter(item?.customization);
  const heartIconFilter = useMemo(
    () => HexToHueConverter(customization?.heartIconColor),
    [customization?.heartIconColor],
  );
  const cartIconFilter = useMemo(() => HexToHueConverter(customization?.cartIconColor), [customization?.cartIconColor]);
  const discountIconFilter = useMemo(
    () => HexToHueConverter(customization?.discountIconColor),
    [customization?.discountIconColor],
  );

  const renderImages = (isDynamic ? dynamicImages : images).map((imgObj, index) => (
    <Product
      productWidth={productWidth}
      customization={customization}
      imgObj={imgObj}
      key={index}
      iconFilters={{ heartIconFilter, cartIconFilter, discountIconFilter }}
    />
  ));

  const getProducts = async (sourceId, limit, type) => {
    const baseDynamicImages = Array.from({ length: limit }, (_, index) => ({
      image: {
        src: process.env.REACT_APP_PRELOADER_IMAGE,
        text: '',
      },
      pointTo: {
        pointTo: '',
        pointToType: '',
      },
      id: '',
      useCustomImage: true,
      useCustomText: true,
    }));
    const selectedHash = collectionHashMap[sourceId + '_' + limit + '_' + type];
    console.log(selectedHash, sourceId + '_' + limit + '_' + type, collectionHashMap, 'collectionHashMap');
    if (selectedHash) {
      if (!(selectedHash?.length > 0)) {
        setDynamicImages(
          baseDynamicImages?.map(e => ({
            ...e,
            image: { src: process.env.REACT_APP_DEFAULT_IMAGE, text: translate('exampleProduct') },
          })),
        );
        return;
      }
      return setDynamicImages(selectedHash);
    }
    setDynamicImages(baseDynamicImages);

    const productData = await getProductWithCategoryId({ sourceId, limit, type });
    if (!productData || !(productData?.results?.length > 0)) {
      setDynamicImages(
        baseDynamicImages?.map(e => ({
          ...e,
          image: { src: process.env.REACT_APP_DEFAULT_IMAGE, text: translate('exampleProduct') },
        })),
      );
      return;
    }

    const newDynamicImages = productData?.results?.map((product, index) => {
      const image = createImageUrl(product?.variants?.[0]?.images?.[0]?.id, merchantId);
      const name = product?.name;
      return {
        image: {
          src: image,
          text: name,
        },
        pointTo: {
          pointTo: '',
          pointToType: '',
        },
        id: product?.id,
        useCustomImage: true,
        useCustomText: true,
      };
    });
    const newHash = {};
    newHash[sourceId + '_' + limit + '_' + type] = newDynamicImages;
    dispatch(themeSlice.actions.setCollectionHashMap(newHash));

    setDynamicImages(newDynamicImages);
  };
  useEffect(() => {
    if (dynamicImage && isDynamic) {
      getProducts(dynamicImage?.pointTo?.pointTo, dynamicImage?.dynamicLimit, dynamicImage?.pointTo?.pointToType);
    }
  }, [dynamicImage?.pointTo?.pointTo, dynamicImage?.dynamicLimit]);
  return (
    <>
      {isDynamic || images?.length >= min ? (
        <div
          className="`overflow-x-visible relative"
          style={{
            padding: `${customization?.containerPadding}`,
            backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
            backgroundImage:
              customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          <div className={`collection-slider relative `}>
            <div
              style={{
                fontWeight: customization?.textWeight,
                fontStyle: customization?.textStyle,
                fontSize: customization?.textSize,
                color: customization?.textColor,
                textAlign: customization?.textAlignment,
                letterSpacing: customization?.textLetterSpacing,
                marginRight: '10px',
                marginLeft: '10px',
              }}
            >
              {item?.data?.text}
            </div>
            <div className="flex flex-row flex-wrap ">{renderImages}</div>
            <div className=""></div>
          </div>
        </div>
      ) : (
        <img src={item?.placeholderImage} className={` w-full `} />
      )}
    </>
  );
}

export default BaseProductGrid;
